import { Flex, Spin } from "antd";

const Loading = () => {
  return (
    <Flex align="center" justify="center">
      <Spin size="large" />
    </Flex>
  );
};

export default Loading;
